'use strict';

angular.module('far.admin')
    .controller('DiscountServiceEditController', function ($log, $http, $window, discountServices, discountServiceForm, showModalMessage, softdeleteable) {
        var vm = {
            progress: true,
            discountServiceModel: discountServiceForm,
            isDeleted: false,
            delete: onDelete,
            restore:onRestore,
            submit: onSubmit,
            getDiscountService: getDiscountService
        };

        vm.discountServiceModel.$fields.image.uploader.onSuccessItem = function(item, response){
            vm.discountService.image = response
        };

        function onDelete() {
            vm.isDeleted = true;
            softdeleteable.delete(vm.discountService.id);
        }

        function onRestore() {
            vm.isDeleted = false;
            softdeleteable.restore(vm.discountService.id);
        }

        function onSubmit() {
            vm.discountService.save()
                .then(function (response) {
                    $window.location.href = Routing.generate('admin_discounts_services_edit', {id: response.data.id});
                })
                .catch(function (response) {
                    $log.error(response);
                    showModalMessage('Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.');
                });
        }

        function getDiscountService() {
            softdeleteable.setModel(discountServices);
            if (arguments.length === 0) {
                vm.discountService = discountServices.new({});
                vm.progress = false;
            } else {
                vm.discountService = discountServices.get(arguments[0], function () {
                    vm.progress = false;
                });
            }
        }

        return vm;
    });